import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lmc-env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PaymentsCaConfigService {
  private readonly uri: string = `${environment.DO_URL}/v2/config/payments.ca`;

  constructor(private readonly http: HttpClient) {}

  /**
   * Uploads the 3 Payments Canada numeric-list PDFs and rebuilds the FIF branch
   * cache (clears the table, then inserts all parsed records).
   */
  uploadFifBranchCache(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach((file) => formData.append('files', file, file.name));
    return this.http.post(`${this.uri}/fif-branch-cache`, formData);
  }
}